export default __webpack_public_path__ + "static/media/safe2.f9633d99.png";